import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide} from "../../utilities/selectorHelpers";
import {isPresent} from "../../utilities/general";
import AsnSerializer from "../../serializers/AsnSerializer";
import AsnStore from "../../stores/AsnStore";
import ShippingMethodStore from "../../stores/ShippingMethodStore";
import addressValidationFactory from '../common/AddressValidation.js';
import asnInitialSnapshotChangedFactory from "./businessLogic/asnInitialSnapshotChangedFactory";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

export default function SaveAsn(wizard, {canSave}={}){

  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  // make var name shorter
  let namespace, nameMap, elementsMap;
  const addressValidationModalEl = $("#add-validation-model");
  const asnId = wizardElement.data("asn-id");
  const asnInitialSnapshotChangedChecker = asnInitialSnapshotChangedFactory();

  const addressValidation = addressValidationFactory(addressValidationModalEl, wizardElement, {
    isAlreadyValid: !!asnId
  });

  self.init = function(){
    setMappings();
    setElements();
    bindElements();
  };

  function determineSave(){
    return canSave && canSave();
  }


  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
    // this modal is outside the scope of the wizard...
    // We should be re-using an html template in this frontend
    // project and FILLING it with the appropriate data & bindings
    els.saveDecisionModal = $("#asn-wizard-saveModal");
    els.saveModalConfirm = $("#asn-wizard-modalSaveAndClosePage");
    els.errorModalAsnSave = $("#asn-wizard-errorModal");

    //submit
    els.submitDecisionModal = $("#create-ans-confirm-modal");
    els.submitModalConfirm = $("#createASNConfirmButton");
    els.createASNSuccessAnchor=$(".create-asn-success-anchor");
    els.createASNSuccessModal=$("#createASNSuccessModal");
  }

  function bindElements(){
    els.saveBtn.on("click", function(e){
      e.preventDefault();
      if(determineSave()){
        showSaveModal();
      }
    });

    els.submitBtn.on("click", function(e){
      e.preventDefault();
      showConfirmSubmitModal();
    });

    els.saveModalConfirm.on("click", function(e){
      e.preventDefault();
      const saveUrl = wizardElement.data("save-url");
      saveNow({url: saveUrl, success: saveAsnSuccess, error: saveAsnError});
    });

    els.submitModalConfirm.on("click", function(e){
      e.preventDefault();
      const submitUrl = wizardElement.data("submit-url");
      saveNow({url: submitUrl, success: submitAsnSuccess, error: submitAsnError});
    });

    // $(document).on("click", ".request-quote-btn", function(e){
    //   e.preventDefault();
    //   const csrEmailUrl = wizardElement.data("csr-email-url");
    //   saveNow({url: csrEmailUrl, success: emailSuccess, error: emailError});
    // });
  }

  function saveNow({url, success, error}){
    console.log('saving asn...');
    const data = {
      [nameMap.asnId]: els.asnId.val(),
      [nameMap.facId]: els.facId.val(),
      [nameMap.cadId]: els.cadId.val(),
      [nameMap.locationName]: els.locationName.val(),
      [nameMap.contactPhone]: els.contactPhone.val(),
      [nameMap.contactName]: els.contactName.val(),
      [nameMap.address1]: els.address1.val(),
      [nameMap.address2]: els.address2.val(),
      [nameMap.country]: els.country.val(),
      [nameMap.city]: els.city.val(),
      [nameMap.state]: els.state.val(),
      [nameMap.zip]: els.zip.val(),
	    [nameMap.cadStateText]: els.cadStateText.val(),

    };

    const asn = getAsn();
    /** This logic has been newly added to manage switching cases vs pallet while edit the ASN. We use ASN's status to identify
    the newly created cases or pallet ASN **/
    const asns = AsnStore.getAsns();
		let tempAsn =  _(asns).find((asn2)=>{
      return asn2.status !== "New";
    });
    if(tempAsn && asn!=tempAsn){
      /** copy the necessary information in case we miss from original ASN while switching case or pallet **/
			asn.asnId = tempAsn.id;
      asn.shippingPartner = tempAsn.shippingPartner;
    }
    /** end **/
    const asnSerializer = new AsnSerializer(asn, {includeServices: true});
    data[`${namespace}asn`] = asnSerializer.toJsonNestedIntoPalletsAndCases();
	  data[`${namespace}isShipmentChange`] = isEditingAndDataChangedSinceLoad();
    const addressResponse = addressValidation.getAddressResponse();
    data[`${namespace}validatedAddress`] = JSON.stringify(addressResponse);

    submitModalFlow.showLoadingModal();
    $.ajax({
      data: data,
      url: url,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function showSaveModal(){
    handleGTLMessage();
    els.saveDecisionModal.modal("show");
  }

  function handleGTLMessage(){
    const asn = AsnStore.getAsnWithShippingMethod();
    const isGTL = AsnStore.isGTL(asn);
    if(isGTL){
      // show message
    }else{
      // hide message
    }
  }

  function showConfirmSubmitModal(){
    console.log("determine if is editing and data has changed since load: ", isEditingAndDataChangedSinceLoad());
    els.submitDecisionModal.modal("show");
  }

  function saveAsnSuccess(asnId){
	 if(asnId > 0){
	  EditChecker.setPageClean();
	  submitModalFlow.showSuccessModal();
	  setTimeout(function() {
		  const asnDetailUrl = wizardElement.data("asn-detail-url");
	    location.href = `${asnDetailUrl}&${namespace}asnId=${asnId}`;
	  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

    }else{
	    submitModalFlow.showFailureModal();
    }
  }

  function saveAsnError(){
	  submitModalFlow.showFailureModal();
  }

  // function emailSuccess(asnId){
	 //  if(asnId>0) {
		//   AsnStore.updateAllObjectsAndEmit({requestQuote: true ,asnId: asnId});
	 //  }
  // }

  // function emailError(){
  //   console.log('email failed');
  //   AsnStore.updateAllObjectsAndEmit({requestQuoteFailed: true});
  // }

  function submitAsnSuccess(asnId){
	 if(asnId > 0){
	  EditChecker.setPageClean();
	  submitModalFlow.showSuccessModal();
	  setTimeout(function() {
  	  const asnDetailUrl = wizardElement.data("asn-detail-url");
  		const asnDetailFullURL = `${asnDetailUrl}&${namespace}asnId=${asnId}&${namespace}isShipmentChange=${isEditingAndDataChangedSinceLoad()}`;
  		location.href =asnDetailFullURL;
	  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }else{
      submitModalFlow.showFailureModal();
    }
  }

  function submitAsnError(){
	  submitModalFlow.showFailureModal();
  }

  function setMappings(){
    namespace = wizardElement.data('namespace');

    nameMap = {
      asnId: `${namespace}asnId`,
      facId: `${namespace}facilities`,
      cadId: `${namespace}cadId`,
      locationName: `${namespace}cadLocationName`,
      contactPhone: `${namespace}cadContactPhone`,
      contactName: `${namespace}cadContactName`,
      address1: `${namespace}cadAddress1`,
      address2: `${namespace}cadAddress2`,
      country: `${namespace}cadCountry`,
      city: `${namespace}cadCity`,
      state: `${namespace}states`,
      zip: `${namespace}cadZipcode`,
	    cadStateText: `${namespace}cadStateText`
    };

    elementsMap = _(nameMap).mapObject((name,k)=>{
      return `#${name}`;
    });

    _.extend(elementsMap, {
      saveBtn: ".ship-later-btn",
      submitBtn : "#submit-asn",
      requestQuote : "#request-quote-btn"
    });
  }

  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function isEditingAndDataChangedSinceLoad(){
    return !!(isEditing() && hasDataChangedSinceLoad());
  }

  function isEditing(){
    return isPresent(asnId);
  }

  function hasDataChangedSinceLoad(){
    return !!asnInitialSnapshotChangedChecker.didStoresDataChange();
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/SaveAsn.js